import React from 'react';

const StandardsCompliance = () => {
  const standards = [
    {
      code: "IEC 61508",
      title: "Functional Safety of Electrical/Electronic/Programmable Electronic Safety-related Systems",
      description: "The foundational standard for functional safety across all industries",
      icon: "fas fa-microchip"
    },
    {
      code: "IEC 61511",
      title: "Functional Safety - Safety Instrumented Systems for the Process Industry Sector",
      description: "Specific application of IEC 61508 for the process industry",
      icon: "fas fa-industry"
    }
  ];

  return (
    <section className="min-h-screen flex items-center py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto w-full">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Standards & Compliance</h2>
          <p className="text-xl text-gray-600">Meeting and exceeding international safety standards</p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {standards.map((standard, index) => (
            <div key={index} className="bg-gray-50 p-8 rounded-lg hover:shadow-lg transition-shadow">
              <div className="flex items-start space-x-4">
                <i className={`${standard.icon} text-3xl text-blue-600 flex-shrink-0 mt-1`}></i>
                <div>
                  <h3 className="text-2xl font-bold text-blue-600 mb-2">{standard.code}</h3>
                  <h4 className="text-lg font-semibold text-gray-900 mb-3">{standard.title}</h4>
                  <p className="text-gray-600">{standard.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white p-12 rounded-lg">
          <div className="max-w-4xl mx-auto text-center">
            <i className="fas fa-award text-6xl mb-6 block"></i>
            <h3 className="text-3xl font-bold mb-4">TÜV Functional Safety Certified Engineers</h3>
            <p className="text-xl leading-relaxed">
              Our team includes TÜV-certified functional safety engineers, ensuring the highest level of expertise 
              and adherence to international standards in all our projects.
            </p>
          </div>
        </div>
        
        <div className="mt-12 relative">
          <img
            src="/assets/asset-20.jpg"
            alt="Compliance documentation"
            className="w-full rounded-lg shadow-xl"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-white/80 to-transparent rounded-lg"></div>
        </div>
      </div>
    </section>
  );
};

export default StandardsCompliance;
